import ComponentWithSocket from '../../../lib/component';
import { Component } from 'vue-property-decorator';

import * as Store from '../../../store';

import template from './reset.vue';

@Component({
    mixins: [template]
})

export default class PasswordResetScreen extends ComponentWithSocket {

    private resetToken: string;
    private password: string;
    private repassword: string;

    private data: {
        errorText: string
        successMessage: boolean
    } = {
        errorText: '',
        successMessage: false
    };

    constructor() {

        super();

        // Assign session values to store for global dispatch
        this.wsListener.onPost('auth.password.reset', (success: boolean, data: any) => {

            Store.commitLoaderVisibility(this.$store, false);

            if (!success) {
                this.data.errorText = data;
                return;
            }

            this.data.errorText = '';
            this.data.successMessage = true;

        });

    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {

        this.resetToken = this.$router.currentRoute.params.token;

    }

    doPasswordReset() {

        // Do some validation
        if (this.repassword !== this.password) {
            this.data.errorText = 'Parolele introduse nu conincid';
            return;
        }

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('auth.password.reset', {
            token: this.resetToken,
            password: this.password
        });

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/password/reset/index.ts